import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { LoginModel } from '@login/model/login.model';
import { LoginService } from '@services/login/login.service';
import { UserService } from '@services/user/user.service';

// Load environment setting
import { environment } from '@environments/environment';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { PrivacyPolicyComponent } from '../privacy-policy/privacy-policy.component';
import { ModalComponent } from '../../../common_libraries/controls/modal/modal.component';
import { FormThrobberButtonComponent } from '../../../common_libraries/controls/form-throbber-button/form-throbber-button.component';
import { ValidationNotificationComponent } from '../../../common_libraries/controls/validation-notification/validation-notification.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GenericServiceCompleteComponent } from '../../../common_libraries/controls/generic-service-complete/generic-service-complete.component';
import { FormControlPipe } from '@common_libraries/helpers/pipes/form-control.pipe';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    providers: [LoginModel, LoginService, UserService],
    standalone: true,
    imports: [FormControlPipe, GenericServiceCompleteComponent, FormsModule, ReactiveFormsModule, ValidationNotificationComponent, FormThrobberButtonComponent, RouterLink, ModalComponent, PrivacyPolicyComponent]
})
export class LoginComponent implements OnInit {
  environmentName = environment.envName;

  constructor(private route: ActivatedRoute, public model: LoginModel) {  }

  ngOnInit() {
    this.model.initModel(this.route);
  }

  onSubmitLoginForm(form: any) {
    // this.model.userAcceptedTerms();
    this.model.onSubmitLoginForm(form);
  }

  onNextLoginForm(form: any) {
    // this.model.userAcceptedTerms();
    this.model.onNextLoginForm(form);
  }

  onSubmitResetForm(form: any) {
    this.model.onSubmitResetForm(form);
  }
}
